export const H1 = 'h1';
export const H2 = 'h2';
export const H3 = 'h3';
export const H4 = 'h4';
export const NONE = 'none';
export const FALCONDESCRIPTION = 'falconDescription';
export const FALCONDESCRIPTIONLIST = 'falconAccordionList';
export const SPACER = 'spacer';
export const COUNTRYLISTCOMPONENT = 'countryListComponent';
export const SBCONSTANT = 'sbstaticcontent';
export const CHF = 'CHF';
export const FIXNET = 'fixnet';
export const DEFAULT_WIRELINE_BUNDLE = 'defaultWirelineBundle';
export const DEFAULT_MOBILEPOSTPAID_BUNDLE = 'defaultMobilePostpaidBundle';
export const QOQA = 'QoQa';
export const VCTYPE = 'vctype';
export const VOUCHER = 'voucher';
export const VOUCHERTYPE = 'voucherType';
export const VOUCHERCODE = 'voucherCode';
export const AFTER = 'after';
export const BEFORE = 'before';
export const SMARTPHONEDEVICE = 'smartphone';
export const ONE_ECOMMERCE_HARDWARE_SUMMARY = 'one-ecommerce-hardwareSummary';
export const BASE_PRICE = 'basePrice';
export const INSTALLMENTS = 'installments';
export const SMARTUPGRADEINSTALLMENTS = 'smartUpgradeInstallments';
export const BASE = 'BASE';
export const CONTRACT = 'CONTRACT';
export const HARDWARE = 'HARDWARE';
export const DEFAULT_AVAILABILITY_TEXT = 'dd_delivery_details';
export const DEVICE_INSURANCE = 'DEVICE_INSURANCE';
export const NOT_AVAILABLE = 'NOT_AVAILABLE';
export const ICONIC_FLEX_UPGRADE_BENEFIT = 'ICONIC_FLEX_UPGRADE_BENEFIT';
export const FLEX_UPGRADE = 'Flex Upgrade';
export const WP_FLEX_UPGRADE = 'FLEX_UPGRADE';
export const WP_FLEX_UPGRADE_NOT = 'FLEX_UPGRADE_NOT';
export const EXCLUSIVE_BENEFIT_COLOR = '#008187';
export const ULTIMATEBUNDLE = 'ultimateBundle';
export const ONE_ECOMMERCE_INTERNET_SUMMARY = 'one-ecommerce-internetSummary';
export const CODE = 'code__';
export const DPSUBSIDYPROMOTION = 'dPSubsidyPromotion';
export const PROMO = 'PROMO';
export const PROCEED_BUTTON = 'proceedButton';
export const ONE_ECOMMERCE_SUMMARY = 'one-ecommerce-summary';
export const WIN = 'WIN';
export const HARDWAREGROUPNAME = 'hardwareGroupName';
export const ONE_ECOMMERCE_OTT = 'one-ecommerce-ott';

//viewports
export const MOBILE = 'mobile';
export const DESKTOP = 'desktop';
export const LARGE_DESKTOP = 'large-desktop';
export const TABLET = 'tablet';
export const INTERNET = 'internet';
export const YOUTH = 'YOUTH';
export const CURRENCY = 'CHF';
export const DEFAULT = 'default';
export const QOQA_RATE_PLAN = 'QOQA_RATE_PLAN';

export const AVAILABLE_LANGUAGES = {
  EN: 'English',
  FR: 'Français',
  IT: 'Italiano',
  DE: 'Deutsch'
};

export const ERROR_COLOR = '#C60047';
export const BREADCRUMB = '...';
export const PRE_TO_POST = 'PRE_TO_POST';
export const P2PSUBSCRIBEDPLAN = 'Sunrise Prepaid Unlimited';
export const TV_SERVICE_OPTION = 'TV_SERVICE_OPTION';

export const PRIMARYCOLORS = '#da291c';
export const CENTER = 'center';
export const RIGHT = 'right';
export const ZEROES = '00';
export const LEFT = 'left';
export const COLORWHITE = '#ffffff';
export const TRANSPARENT = 'transparent';
export const INTERNET_SERVICE_OPTION = 'INTERNET_SERVICE_OPTION';
export const VOICE_SERVICE_OPTION = 'VOICE_SERVICE_OPTION';
export const MOBILEPOSTPAID_SERVICE_OPTION = 'MOBILEPOSTPAID_SERVICE_OPTION';

//ReactInputSelect color consts
export const ERROR_BORDER = '#BF0760';
export const DISABLED_BACKGROUND = '#E6E3DF';

//Login MFA Status constants
export const LOGIN_MFA = 'LOGIN_MFA';
export const DEPRICATING_SMS = 'DEPRICATING_SMS';
export const DEPRICATING_EMAIL = 'DEPRICATING_EMAIL';
export const DEPRICATED_EMAIL = 'DEPRICATED_EMAIL';
export const OTP_NR_LIST = 'OTP_NR_LIST';
export const PW_CHANGED = 'PW_CHANGED';
export const OTP_SMS_OLD = 'OTP_SMS_OLD';
export const OTP_SMS_NEW = 'OTP_SMS_NEW';
export const OTP_SMS = 'OTP_SMS';
export const OTP_EMAIL = 'OTP_EMAIL';
export const OTP_NR_NEW = 'OTP_NR_NEW';
export const LOGIN_OTP = 'LOGIN_OTP';
export const PW_RESET = 'PW_RESET';
export const OTP_NR_ADD = 'OTP_NR_ADD';
export const OTP_NR_CONFIRM = 'OTP_NR_CONFIRM';
export const OTP_NR_CHANGE = 'OTP_NR_CHANGE';
export const OTP_CONTINUE = 'OTP_CONTINUE';
export const OTP_RESEND = 'OTP_RESEND';
export const PW_FORGOT = 'PW_FORGOT';

//Device Constants US_349849
export const MONTHLY = 'monthly_24';
export const ACCESSORY = 'ACCESSORY';
export const ADD = 'ADD';
export const UPDATE = 'UPDATE';
export const FLOWINTITIATED = 'flowInitiated';
export const MONTHLYFLASHDISCOUNT = 'monthlyFlashDiscount';
export const REMOVE = 'REMOVE';
export const TOTALFLASHDISCOUNT = 'totalFlashDiscount';
export const MOBILEACCESSORIES = 'mobileaccessories';
export const ONETIME = 'none';
export const LAZYLOAD = 'lazy';
export const CONTAIN = 'contain';
export const COVER = 'cover';
export const ACCESSORYLABEL = 'accessoriesLabel';
export const VASSTEPPERLABEL = 'vasStepperLabel';
export const MULTIPLEITEMACCESSORIES = 'MULTIPLE_ITEM_ACCESSORIES';
export const TABLETS = 'TABLETS';
export const WATCHES = 'WATCHES';

//Prices toggle constants
export const NEW = 'new';
export const HIDE = 'hide';
export const DISABLE = 'disable';

// MIA constants
export const MOBILERATEPLAN = 'MOBILE';
export const INTERNETFLOW = 'INTERNET';
export const TV = 'TV';
export const DATA_POSTPAID = 'DATA_POSTPAID';
export const EXTRASIM_RATEPLAN = 'EXTRASIM_RATEPLAN';
export const RATEPLAN = 'RATEPLAN';

// Note author constants
export const HARDWARE_CONFIGURATION = 'hardwareConfiguration';
export const HARDWARE_IMAGE_URL = 'hardwareImageUrl';
export const HARDWARE_CATEGORY = 'hardwareCategory';
export const UPFRONT = 'upfront';

// Hardware category values
export const SMARTWATCH = 'smartwatch';
export const TABLET_CATEGORY = 'tablet';

export const HOMESECURITYPAGETYPE = 'HOME_SECURITY';
